export default "__VITE_ASSET__FDb53_uU__"